import { ReactNode } from "react";
import clsx from "clsx";

export const TopbarTitle = ({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) => {
  return (
    <p className={clsx("text-lg font-semibold text-slate-700", className)}>
      {children}
    </p>
  );
};
